import React from 'react';
import '../less/index.less';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import TextBlock from '../../../../../auxiliary-components/shared/TextBlock';
import QuestionsNew from '../../../../../auxiliary-components/shared/QuestionsNew';
import VerticalTabs from '../../../../../auxiliary-components/shared/VerticalTabs';
import { Link } from 'MWC';
import SegmentedStorybook from '@abank/abank-segmented';
import DOMPurify from 'utils/sanitize';
import questionsItems from '../enums/questions_items.json';
import advantagesItemsTop from '../enums/advantages_items_top.json';
import advantagesItemsBottom from '../enums/advantages_items_bottom.json';
import { openBankingLink } from '../../../../../services/urls/urls';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import accountsTableData from '../enums/accounts_table_data.json';
import parametersTableData from '../enums/parameters_table_data.json';
import { Preloader } from 'MWComponents';

export default function template() {
  const tabs = [{tab: 'what-is', title: 'OPEN_BANKING_TABS_TITLE_01'},
          {tab: 'sandbox', title: 'OPEN_BANKING_TABS_TITLE_02'},
          {tab: 'productive-environment', title: 'OPEN_BANKING_TABS_TITLE_03'},
          {tab: 'account-info', title: 'OPEN_BANKING_TABS_TITLE_04'},
          {tab: 'accessibility-statistics', title: 'OPEN_BANKING_TABS_TITLE_05'}];

  const verticalTabs = [{tab: 'creating-consent', name: 'OPEN_BANKING_VERTICAL_TABS_TITLE_01'},
        {tab: 'initiating-authorization', name: 'OPEN_BANKING_VERTICAL_TABS_TITLE_02'},
        {tab: 'consent-confirmation', name: 'OPEN_BANKING_VERTICAL_TABS_TITLE_03'},
        {tab: 'checking-status', name: 'OPEN_BANKING_VERTICAL_TABS_TITLE_04'},
        {tab: 'getting-identifiers', name: 'OPEN_BANKING_VERTICAL_TABS_TITLE_05'},
        {tab: 'information-retrieval', name: 'OPEN_BANKING_VERTICAL_TABS_TITLE_06'},
        {tab: 'revoke-consent', name: 'OPEN_BANKING_VERTICAL_TABS_TITLE_07'},
        {tab: 'creating-consent-yuo-fop', name: 'OPEN_BANKING_VERTICAL_TABS_TITLE_08'}];

  const segmentedTabs = verticalTabs.map(tab => ({
    ...tab,
    name: this.l10n(tab.name)
  }));

  const accountInfoTabsContent = [
    'OPEN_BANKING_ACCOUNT_INFO_TAB_CONTENT_1',
    'OPEN_BANKING_ACCOUNT_INFO_TAB_CONTENT_2',
    'OPEN_BANKING_ACCOUNT_INFO_TAB_CONTENT_3',
    'OPEN_BANKING_ACCOUNT_INFO_TAB_CONTENT_4',
    'OPEN_BANKING_ACCOUNT_INFO_TAB_CONTENT_5',
    'OPEN_BANKING_ACCOUNT_INFO_TAB_CONTENT_6',
    'OPEN_BANKING_ACCOUNT_INFO_TAB_CONTENT_7',
    {
      type: 'custom',
      render: () => (
        <>
          <div className="creating-consent-yuo-fop__accounts-table">
            <TransferTableNew data={accountsTableData} title="OPEN_BANKING_ACCOUNT_INFO_TAB_ACCOUNTS_TABLE_TITLE" titleTag="div"/>
          </div>
          <div className="creating-consent-yuo-fop__parametrs-table">
            <TransferTableNew data={parametersTableData} title="OPEN_BANKING_ACCOUNT_INFO_TAB_PARAMETRS_TABLE_TITLE" titleTag="div"/>
          </div>
          <div className="creating-consent-yuo-fop__logic">
            <h3 className="creating-consent-yuo-fop__subtitle">{this.l10n('OPEN_BANKING_ACCOUNT_INFO_TAB_LOGIC_SUBTITLE')}</h3>
            <div className="creating-consent-yuo-fop__text">
              <p>{this.l10n('OPEN_BANKING_ACCOUNT_INFO_TAB_LOGIC_TEXT_01')}</p>
              <p>{this.l10n('OPEN_BANKING_ACCOUNT_INFO_TAB_LOGIC_TEXT_02')}</p>
              <p  dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n('OPEN_BANKING_ACCOUNT_INFO_TAB_LOGIC_TEXT_03'))}}></p>
            </div>
          </div>
          <div className="creating-consent-yuo-fop__confirm">
            <h3 className="creating-consent-yuo-fop__subtitle">{this.l10n('OPEN_BANKING_ACCOUNT_INFO_TAB_CONFIRM_SUBTITLE')}</h3>
            <div className="creating-consent-yuo-fop__text">
              <p>{this.l10n('OPEN_BANKING_ACCOUNT_INFO_TAB_CONFIRM_TEXT_01')}</p>
              <p>{this.l10n('OPEN_BANKING_ACCOUNT_INFO_TAB_CONFIRM_TEXT_02')}</p>
            </div>
          </div>
        </>
      )
    }
  ];

  const renderAccountInfoTab = (item, index) => {
    const content = typeof item === 'string' ? (
      <div className="container" key={index}>
        <div
          key={index}
          className="account-info-tab"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(this.l10n(item))
          }}
        />
      </div>
    ) : item.type === 'custom' ? (
      <div className="container" key={index}>
        <div key={index} className="account-info-tab-custom">
          {item.render()}
        </div>
      </div>
    ) : null;

    return content;
  };

  const accessibilityStatisticsTableData = {
      headers: ['OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_CELL_1_1', 'OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_CELL_1_2', 'OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_CELL_1_3'],
      columns: ['quarter', 'avg_availability_percent', 'avg_response_time_ms'],
      data: (this.state.accessibilityStatisticsData || []).map(item => ({
          id: item.quarter,
          quarter: `${item.quarter} ${this.l10n('OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_CELL_2_1')} ${new Date().getFullYear()}`,
          avg_availability_percent: `${item.metrics.avg_availability_percent} ${this.l10n('PERCENT')}`,
          avg_response_time_ms: `${item.metrics.avg_response_time_ms} ${this.l10n('OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_CELL_3_1')}`
      }))
  };

  const accessibilityStatisticsTableEmptyData = {
      headers: ['OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_CELL_1_1', 'OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_CELL_1_2', 'OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_CELL_1_3'],
      columns: ['quarter', 'avg_availability_percent', 'avg_response_time_ms'],
      data: [
        { 
          quarter: `${this.l10n('OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_EMPTY_CELL_2_1')} ${new Date().getFullYear()}`, 
          avg_availability_percent: `${this.l10n('OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_EMPTY_CELL_2_2')}`, 
          avg_response_time_ms: this.state.isAccessibilityTableMobile ? `${this.l10n('OPEN_BANKING_ACCOUNT_STATISTICS_TAB_TABLE_EMPTY_CELL_3_2')}` : ''
        }
      ]
  };

  const isAccessibilityStatisticsDataExists = this.state.accessibilityStatisticsData && this.state.accessibilityStatisticsData.length > 0;

  return (
    <div className="open-banking-page">
      <div className="content">
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} showArrows>
          <div className="open-banking-page__about">
            <div>
              <Advantages items={advantagesItemsTop} itemTitleTag={"h2"}/>
              <Advantages items={advantagesItemsBottom} itemTitleTag={"h2"}/>
            </div>
            <div className="open-banking-page__procedure procedure">
              <div className="container">
                <div className="procedure__body">
                  <InfoBlock 
                    title={'OPEN_BANKING_ABOUT_TAB_INFO_TITLE'}
                    middleText={'OPEN_BANKING_ABOUT_TAB_INFO_MIDDLE_TEXT'}
                    text={`OPEN_BANKING_ABOUT_TAB_INFO_TEXT_01`} 
                  />
                  <InfoBlock text={`OPEN_BANKING_ABOUT_TAB_INFO_TEXT_02`} />
                  <TitleBlock title={'OPEN_BANKING_ABOUT_TAB_TITLE'} />
                  <TextBlock text={'OPEN_BANKING_ABOUT_TAB_TEXT'} />
                  <Link 
                    href={"/openbanking/routine_work"} 
                    onClick={e => this.navigate("/openbanking/routine_work", e)} 
                    className="procedure__btn" 
                  >
                    {this.l10n('OPEN_BANKING_ABOUT_TAB_BTN')}
                  </Link>
                </div>
              </div>
            </div>
            <QuestionsNew
              title={'OPEN_BANKING_QUESTIONS_BLOCK_TITLE'}
              items={questionsItems}
            />
            <div className="open-banking-page__for-developers for-developers">
              <div className="container">
                <div className="for-developers__body">
                  <TitleBlock title={'OPEN_BANKING_FOR_DEVELOPERS_TITLE'} />
                  <div className="for-developers__text">{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_01')}</div>
                  <div className="for-developers__text">
                    <p><b>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_02')}</b></p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_03')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_04')}</p>
                  </div>
                  <div className="for-developers__text">
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_05')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_06')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_07')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_08')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_09')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_10')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_11')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_12')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_13')}</p>
                    <p>{this.l10n('OPEN_BANKING_FOR_DEVELOPERS_TEXT_14')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="open-banking-page__sandbox sandbox">
            <div className="container">
              <div className="sandbox__body">
                <h2 className="sandbox__title">{this.l10n('OPEN_BANKING_SANDBOX_TAB_TITLE')}</h2>
                <div className="sandbox__text">
                  <p>{this.l10n('OPEN_BANKING_SANDBOX_TAB_MIDDLE_TEXT_01')}</p>
                  <p>{this.l10n('OPEN_BANKING_SANDBOX_TAB_MIDDLE_TEXT_02')}</p>
                  <p><b>{this.l10n('OPEN_BANKING_SANDBOX_TAB_MIDDLE_TEXT_03')}</b></p>
                </div>
                <a className="sandbox__btn" href={openBankingLink} target="_blank" rel="noopener noreferrer">{this.l10n('OPEN_BANKING_SANDBOX_TAB_BTN')}</a>
                <InfoBlock 
                  text={`OPEN_BANKING_SANDBOX_TAB_INFO_TEXT`} 
                />
              </div>
            </div>
          </div>
          <div className="open-banking-page__productive">
            <InfoBlock 
              title={'OPEN_BANKING_SANDBOX_TAB_PRODUCTIVE_TITLE'}
              text={`OPEN_BANKING_SANDBOX_TAB_PRODUCTIVE_TEXT`} 
            />
          </div>
          <div className="open-banking-page__account-info">
            <TitleBlock title={'OPEN_BANKING_ACCOUNT_TAB_TITLE'} />
            <TextBlock text={'OPEN_BANKING_ACCOUNT_TAB_TEXT'} />
            {!this.state.isSegmentedCollapsed ? (
              <VerticalTabs tabs={verticalTabs} toggle={this.toggleVerticalTab} tab={this.state.verticalTab}>
                {accountInfoTabsContent.map((item, index) =>
                  renderAccountInfoTab(item, index)
                )}
              </VerticalTabs>
            ) : (
              <SegmentedStorybook 
                collapsed={true} 
                tabs={segmentedTabs} 
                tab={this.state.verticalTab} 
                toggle={this.toggleVerticalTab} 
                leadIcon={false}
              >
                {accountInfoTabsContent.map((item, index) =>
                  renderAccountInfoTab(item, index)
                )}
              </SegmentedStorybook>
            )}
          </div>
          <div className={`open-banking-page__accessibility-statistics ${isAccessibilityStatisticsDataExists ? 'open-banking-page__accessibility-statistics_exists'
                : ''
            }`}
          >
            {this.state.accessibilityStatisticsLoader ? (
              <Preloader />
            ) : this.state.accessibilityStatisticsError ? (
              <div className="open-banking-page__accessibility-statistics-error">
                <TextBlock text={this.state.accessibilityStatisticsError} />
              </div>
            ) : isAccessibilityStatisticsDataExists ? (
              <TransferTableNew data={accessibilityStatisticsTableData} />
            ) : (
              <TransferTableNew data={accessibilityStatisticsTableEmptyData} />
            )}
          </div>
        </Tabs>
      </div>
    </div>
  );
}
